import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { DRAWER_WIDTH } from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/components/HelpBar';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HelpIcon from '@mui/icons-material/Help';

/**
 * Wrapping component for form layout
 * @param {function} props.setOpen
 * @param {string} props.title
 * @param {ReactElement} props.children
 * @returns {ReactElement} Layout to standardize form display
 */
const FormLayout = ({ setOpen, title, children }) => {
	return (
		<>
			<Box
				sx={{
					padding: 2,
					width: '100%',
					pl: { xs: 0, sm: 0, md: 5, lg: 10, xl: 15 },
					pr: { xs: 0, sm: 0, md: 5, lg: 10, xl: 15 },
				}}
			>
				<Card>
					<CardContent>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'flex-start',
							}}
						>
							<Typography
								gutterBottom
								variant='h5'
								component='div'
								color='primary'
							>
								{title}
							</Typography>
							<Button startIcon={<HelpIcon />} onClick={setOpen}>
								Help
							</Button>
						</Box>
						<>{children}</>
					</CardContent>
				</Card>
			</Box>
		</>
	);
};

FormLayout.propTypes = {
	children: PropTypes.node.isRequired,
	setOpen: PropTypes.func.isRequired,
	title: PropTypes.string,
};

export default FormLayout;
